"use strict";
/*
 * Copyright (c) 2018 - Present, Vamstar Limited
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or
 * without modification, are not permitted.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.Status = void 0;
var Status;
(function (Status) {
    Status[Status["NEEDS_APPROVAL"] = 0] = "NEEDS_APPROVAL";
    Status[Status["ACTIVE"] = 1] = "ACTIVE";
    Status[Status["INACTIVE"] = 2] = "INACTIVE";
    Status[Status["ARCHIVED"] = 3] = "ARCHIVED";
})(Status = exports.Status || (exports.Status = {}));
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoic3RhdHVzLWVudW0uanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi9zcmMvY29tbW9uL2VudW1zL3N0YXR1cy1lbnVtLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7QUFBQTs7Ozs7O0dBTUc7OztBQUVILElBQVksTUFLWDtBQUxELFdBQVksTUFBTTtJQUNoQix1REFBa0IsQ0FBQTtJQUNsQix1Q0FBVSxDQUFBO0lBQ1YsMkNBQVksQ0FBQTtJQUNaLDJDQUFZLENBQUE7QUFDZCxDQUFDLEVBTFcsTUFBTSxHQUFOLGNBQU0sS0FBTixjQUFNLFFBS2pCIn0=